
import {FeatureFlags} from '~commonInfra/featureFlags/FeatureFlags';

import {Sites} from '../../siteManagement/services/resources/Sites';
import {
  IDashExtServerSettings,
  IExtsvcServerSettings
} from '../ServerApi/types/IEditableServerSettings';
import {ServerSettingsInstance} from '../services/ServerSettings';
import {
  IAnalyticsExtSiteSettings,
  ISiteSettingsForSiteAdmin,
} from '../types/ISiteSettingsForSiteAdmin';
import {IGetDashExtSiteSettingsResult} from './serverApi/requests/dashboard/GetExtensionsSiteSettingsRequest';

export interface ExtensionsSettingsSubspaceState {
  readonly isServerPage: boolean;
  readonly hasDataToRender: boolean;
  readonly hasError: boolean;
  readonly dashExtServerSettings: IDashExtServerSettings;
  readonly dashExtSiteSettings: IGetDashExtSiteSettingsResult;
  readonly extsvcServerSettings: IExtsvcServerSettings;
  readonly analyticsExtensionsServerSettings: IExtsvcServerSettings;
  readonly analyticsExtensionsSiteSettings: IAnalyticsExtSiteSettings;
  readonly siteSettingsForSiteAdmin: ISiteSettingsForSiteAdmin;
}

export type UpdateCallback = (settings: Partial<ExtensionsSettingsSubspaceState>) => void;

export function getData(updateCallback: UpdateCallback, errorCallback: (e: Error) => void) {
  try {
    // Extensions site and server settings are tightly coupled. Site needs to know if server level is on, etc. 
    //  This is true for dashboard extensions and analytics extensions. Prep has one section which uses their 
    //  settings data call in both server and site settings.
    const settingsCalls = [
      RequestAndUpdate(updateCallback, 'dashExtServerSettings', async () => { return ServerSettingsInstance.getExtensionsSettings(); }),
      RequestAndUpdate(updateCallback, 'dashExtSiteSettings', async () => { return Sites.instance.getCurrentExtensionsSiteSettingsForSiteAdmin(); }),

      RequestAndUpdate(updateCallback, 'analyticsExtensionsServerSettings', async () => { return ServerSettingsInstance.getAnalyticsServerLevel(); }),
      RequestAndUpdate(updateCallback, 'analyticsExtensionsSiteSettings', async () => { return ServerSettingsInstance.getAnalyticsSiteLevel(); }),
      RequestAndUpdate(updateCallback, 'extsvcServerSettings', async () => { return ServerSettingsInstance.getExtsvcSettings(); }),
    ];

    if (FeatureFlags.prepExtensionsEinstein) {
      settingsCalls.push(RequestAndUpdate(updateCallback, 'siteSettingsForSiteAdmin', async () => { return Sites.instance.getCurrentSiteSettingsForSiteAdmin(); }));
    }

    Promise.all(settingsCalls);
  } catch (e) {
    errorCallback(e);
  }
}

async function RequestAndUpdate<K extends keyof ExtensionsSettingsSubspaceState>(updateCallback: UpdateCallback, key: K, requestFunction: () => Promise<any>) {
  let data: Partial<ExtensionsSettingsSubspaceState> = {};
  data[key] = await requestFunction();
  updateCallback(data);
}